import React from 'react';
import { Line as LineChart } from 'react-chartjs';


class Charts extends React.Component {
  constructor() {
    super();
    const data = {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [{
        label: 'My First dataset',
        fillColor: "rgba(98,107,227,0.2)",
        strokeColor: "rgba(98,107,227,1)",
        pointColor: "rgba(98,107,227,1)",
        pointStrokeColor: "#fff",
        data: [65, 35, 80, 200, 56, 55, 40],
        fill: false,
      }, {
        label: 'My Second dataset',
        fill: false,
        fillColor:  "rgba(74, 171, 237, 0.2)",
        strokeColor: "rgba(108,187,247,1)",
        pointColor: "rgba(0,186,255,1)",
        pointStrokeColor: "#fff",
        data: [77, 35, 50, 120, 36, 80, 34],
      }]
    };
    const options = {
      responsive: true,
      title: {
        display: true,
        text: 'Chart.js Line Chart'
      },
      tooltips: {
        mode: 'index',
        intersect: false,
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: 'Month'
          }
        }],
        yAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: 'Value'
          }
        }]
      }
    };
    this.state = {
      chartData: data,
      chartOptions: options,
    };
  }
  render() {
    const { chartData, chartOptions } = this.state;
    return (
      <div>
        <LineChart data={chartData} options={chartOptions} width="600" height="200"/>
      </div>
    )
  }
}

export default Charts;